<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <b-list-group>
        <b-list-group-item
          v-for="item in dataList"
          :key="item.id"
        >
          <div class="d-flex align-items-center justify-content-between">
            <div>{{ item.title }}</div>
            <div>
              <b-badge
                variant="primary"
                pill
              >
                {{ item.count }}
              </b-badge>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
      <div class="text-muted font-italic mt-1">
        En çok başvuru alan 10 konu listelenmektedir.
      </div>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <pie-charts
        :categories-data="chartData.labels"
        :series-data="chartData.series"
        chart-type="donut"
        :is-card="false"
      />
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BListGroup, BListGroupItem, BBadge,
} from 'bootstrap-vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'

export default {
  name: 'ListCard',
  components: {
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    BBadge,
    PieCharts,
  },
  props: {
    cardTitle: {
      type: String,
      default: null,
    },
    cardSubTitle: {
      type: String,
      default: null,
    },
    dataList: {
      type: Array,
      required: true,
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
}
</script>
